



































import Vue from 'vue'
import CheckTable from '../components/History/CheckTable.vue'
import BatchTable from '../components/History/BatchTable.vue'
import ContinuousTable from '../components/History/ContinuousTable.vue'

export default Vue.extend({
  name: 'History',
  components: {
    CheckTable,
    BatchTable,
    ContinuousTable
  },
  data: () => ({
    tableIndex: 'check'
  }),
  computed: {
    selectedTable (): string {
      return `${this.tableIndex}-table`
    }
  },
  methods: {
    changeTable (index: string): void {
      if (index === this.tableIndex) {
        return
      }

      this.tableIndex = index
    }
  }
})
